import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AirConfigService {

  constructor(private http : HttpClient) {}

  getGeneralConfig(userUid:any) {
    
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
   // httpParam=httpParam.append("userUid", userUid);
   
      return this.http.post( environment.API_URL+"/api/product/air/config/getGenConfigs?userUid="+userUid ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  saveGeneral(result:any,uuid:any){
    let headers = new HttpHeaders();
    
    return this.http.post(environment.API_URL+"/api/product/air/config/addConfig/"+uuid,result,{headers : headers,observe:"response"});

  }
  UpdateGeneral(result:any,uuid:any){
    let headers = new HttpHeaders();
    
    return this.http.post(environment.API_URL+"/api/product/air/config/updateConfig/"+uuid,result,{headers : headers,observe:"response"});
    
  }

  getSourceConfig(userUid:any) {
    
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    //httpParam=httpParam.append("userUid", userUid);
   
      return this.http.post( environment.API_URL+"/api/product/air/config/getSourceConfigs?userUid="+userUid,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  saveSource(result:any,uuid:any){
    let headers = new HttpHeaders();
    
    return this.http.post(environment.API_URL+"/api/product/air/sourceConfig/addConfig/"+uuid,result,{headers : headers,observe:"response"});

  }
  updateSource(result:any,uuid:any,sourceCode:any,supplierCode:any)
{ let headers = new HttpHeaders();
    
  return this.http.post(environment.API_URL+"/api/product/air/sourceConfig/updateConfig/"+uuid+"/"+sourceCode+"/"+supplierCode,result,{headers : headers,observe:"response"});

  
}
saveTourCode(result:any,uuid:any){
  let headers = new HttpHeaders();
  
  return this.http.post(environment.API_URL+"/api/product/air/tourCodeConfig/addConfig/"+uuid,result,{headers : headers,observe:"response"});

}
updateTour(result:any,uuid:any)
{ let headers = new HttpHeaders();
    
  return this.http.post(environment.API_URL+"/api/product/air/tourCodeConfig/updateConfig/"+uuid,result,{headers : headers,observe:"response"});

  
}
getTourcode(userUid:any) {
    
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
  //httpParam=httpParam.append("userUid", userUid);
 
    return this.http.post( environment.API_URL+"/api/product/air/config/getTourCodesConfigs?userUid="+userUid,{headers : header, observe : "body", params : httpParam,responseType : "json"})
 
}


savePrivateFare(result:any,uuid:any){
  let headers = new HttpHeaders();
  
  return this.http.post(environment.API_URL+"/api/product/air/privateFareCodeConfig/addConfig/"+uuid,result,{headers : headers,observe:"response"});

}
updatePrivateFare(result:any,uuid:any)
{ let headers = new HttpHeaders();
    
  return this.http.post(environment.API_URL+"/api/product/air/privateFareCodeConfig/updateConfig/"+uuid,result,{headers : headers,observe:"response"});

  
}
getPrivateFare(userUid:any) {
    
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
  //httpParam=httpParam.append("userUid", userUid);
 
    return this.http.post( environment.API_URL+"/api/product/air/config/getPrivateFareCodes?userUid="+userUid,{headers : header, observe : "body", params : httpParam,responseType : "json"})
 
}
getSourceForOfficeId() {
    
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
  //httpParam=httpParam.append("userUid", userUid);
 
    return this.http.post( environment.API_URL+"/api/product/air/config/getSourceConfigsParentUser",{headers : header, observe : "body", params : httpParam,responseType : "json"})
 
}

saveCache(result:any,uuid:any){
  let headers = new HttpHeaders();
  
  return this.http.post(environment.API_URL+"/api/product/air/config/cacheConfig/"+uuid,result,{headers : headers,observe:"response"});

}

getCache(userUid:any) {
    
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
  //httpParam=httpParam.append("userUid", userUid);
 
    return this.http.post( environment.API_URL+"/api/product/air/config/getCacheConfig/"+userUid,{headers : header, observe : "body", params : httpParam,responseType : "json"})
 
}

saveFareRule(result:any,uuid:any){
  let headers = new HttpHeaders();
  
  return this.http.post(environment.API_URL+"/api/product/air/farerules/farerule",result,{headers : headers,observe:"response"});

}
fareRulelist(searchText:any,paginated:any,userId:any) {
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
      httpParam=httpParam.append("searchText", searchText);
      httpParam=httpParam.append("size", paginated.size);
      httpParam=httpParam.append("page", paginated.page);
      if(userId){
      httpParam=httpParam.append("userId", userId);
 }else{
  httpParam=httpParam.append("userId", '');

}

    return this.http.get( environment.API_URL+"/api/product/air/farerules/rules" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
}
rbdList(request:any) {
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/payments/AIR/supplierpayconfig" ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
}

saveRbd(result:any){
  let headers = new HttpHeaders();
  
  return this.http.post(environment.API_URL+"/api/payments/AIR/supplierpayconfig/new",result,{headers : headers,observe:"response"});

}
updatedRbd(result:any,id:any){
  let headers = new HttpHeaders();
  
  return this.http.put(environment.API_URL+"/api/payments/AIR/supplierpayconfig/update/"+id,result,{headers : headers,observe:"response"});

}
getPaymentChannels(){
  let headers = new HttpHeaders();
  return this.http.post(environment.API_URL+"/api/payments/paymentchannels",{headers : headers,observe:"response"});

}
}
